<script>
  import MainMenu from "@/components/template/ui/MainMenu.vue";
  import FormComment from "@/components/template/ui/FormComment.vue";

  export default {
    name: "FooterMain",
    components: {MainMenu, FormComment},
    computed: {
      footerType() {
        return this.$route.meta.footerType || "default";
      }
    }
  }
</script>

<template>
  <footer class="footer">
    <div class="footer__inner" :class="{'footer__inner--comment': footerType === 'comment'}">
      <MainMenu v-if="footerType === 'default'" />
      <FormComment v-if="footerType === 'comment'" />
    </div>
  </footer>
</template>